module.exports = __webpack_public_path__ + "img/eispalast-teaser-2024.0d387091.jpg";